@if (showSubscription()) {
<label class="subscription-card" [ngClass]="{ 'subscription-card--selected': isSelected() }">

  <div class="subscription-card__main">

    <input type="radio" [checked]="isSelected()" [disabled]="disabled()" class="subscription-card__radio-input"
      (change)="payWithCard.emit()" />

    <div class="subscription-card__content">

      <div class="subscription-card__header">
        <h3 class="subscription-card__title">Pago automático con tarjeta</h3>
        <div class="subscription-card__tag">¡Recomendado!</div>
      </div>

      <p class="subscription-card__terms">
        Al elegir este medio de pago, <strong>autorizas el débito automático mensual</strong> del valor de tu seguro
        desde tu tarjeta.
      </p>

      <p class="subscription-card__terms">
        Aplican
        <button type="button" class="subscription-card__terms-link" (click)="openTermsModal()"
          (keydown.enter)="openTermsModal()" (keydown.space)="openTermsModal()">
          Términos y Condiciones
        </button>.
      </p>
    </div>
  </div>
  @if (showPromo()) {
  <div class="subscription-card__promo">
    <img src="./assets/img/Logo_PC.png" alt="Puntos Colombia" class="subscription-card__promo-logo" />

    <div class="subscription-card__promo-content">
      <h4 class="subscription-card__promo-title">
        Recibe 2.000 Puntos Colombia por la activación del débito automático.
      </h4>
      <!-- <p class="subscription-card__promo-description">
        Y 1 punto por cada ${{ pointsPerAmount() | number }} de tu pago mensual
      </p> -->
      <p class="subscription-card__promo-terms">
        Aplican
        <a type="button" class="subscription-card__promo-terms-link"
          href="https://www.sura.co/seguros/digitales/terminos-y-condiciones" target="_blank">
          Términos y condiciones
        </a>
        <!-- (válido del 2 al 30 de junio). -->
      </p>
    </div>
  </div>
  }


  <app-subscription-terms-conditions-modal [isVisible]="isTermsModalVisible" (accepted)="onTermsAccepted()"
    (closed)="closeTermsModal()">
  </app-subscription-terms-conditions-modal>
</label>
}